export const NAME = 'analyticscore'
